import Page from "./pages/Page";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router className="App">
      <Page/>
    </Router>
  );
}

export default App;
